export default __webpack_public_path__ + "static/media/itwlogo.3dc6bcbf.png";